import { equipmentApi } from '../api/modules/equipment.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { getAssets } from '../data/master/equipmentAssetsStore';
import { mapPaginated, equipmentFromApi, equipmentToApi } from '../models';

export async function listEquipment(params = {}) {
  if (!USE_API) {
    let items = [...getAssets()];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (a) =>
          a.assetId?.toLowerCase().includes(q) ||
          a.regNo?.toLowerCase().includes(q) ||
          a.equipmentType?.toLowerCase().includes(q),
      );
    }
    if (params.ownerType) {
      const ot = String(params.ownerType).toLowerCase();
      items = items.filter((a) => String(a.ownerType).toLowerCase() === ot);
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 10;
    const start = (page - 1) * pageSize;
    return {
      items: items.slice(start, start + pageSize),
      total: items.length,
      page,
      pageSize,
    };
  }
  try {
    const result = await equipmentApi.list(params);
    return mapPaginated(result, equipmentFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment'));
  }
}

export async function getEquipment(id) {
  if (!USE_API) {
    return getAssets().find((a) => a.assetId === id) || null;
  }
  try {
    return equipmentFromApi(await equipmentApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment'));
  }
}

export async function createEquipment(ui) {
  if (!USE_API) throw new Error('Create equipment requires API mode');
  try {
    return equipmentFromApi(await equipmentApi.create(equipmentToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create equipment'));
  }
}

export async function updateEquipment(id, ui) {
  if (!USE_API) throw new Error('Update equipment requires API mode');
  try {
    return equipmentFromApi(await equipmentApi.update(id, equipmentToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update equipment'));
  }
}

export async function updateEquipmentKyc(id, body) {
  if (!USE_API) throw new Error('Update equipment KYC requires API mode');
  try {
    return equipmentFromApi(await equipmentApi.updateKyc(id, body));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update equipment KYC'));
  }
}

export async function deleteEquipment(id) {
  if (!USE_API) throw new Error('Delete equipment requires API mode');
  try {
    await equipmentApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete equipment'));
  }
}

export async function getEquipmentIndentHistory(id) {
  if (!USE_API) return [];
  try {
    const rows = await equipmentApi.indentHistory(id);
    return (Array.isArray(rows) ? rows : []).map((row) => ({
      kind: row.kind || '',
      indentId: row.indentId || '',
      indentDbId: row.indentDbId ?? null,
      at: row.at || null,
      status: row.status || '',
      note: row.note || '',
      rating: row.rating != null ? Number(row.rating) : null,
    }));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment history'));
  }
}
